import { observer } from 'mobx-react-lite'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { Box, Button, Checkbox, Typography } from 'shared/ui'
import { type MessagingGeneralStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/general/store/MessagingGeneralStore'
import styles from './styles.module.scss'

type IDeleteInboxModalContentProps = {
  store: MessagingGeneralStore
}

type ICheckboxItem = {
  id: string
  label: string
}

const DELETE_INBOX_CHECKBOXES: ICheckboxItem[] = [
  {
    id: 'checkbox1',
    label: "This can't be undone",
  },
  {
    id: 'checkbox2',
    label: 'Deleting this inbox will also delete all associated numbers',
  },
  {
    id: 'checkbox3',
    label: 'Any broadcast associated with this inbox will be removed',
  },
]

export const DeleteInboxModalContent = observer(({ store }: IDeleteInboxModalContentProps) => {
  const {
    availableInboxes,
    availableInboxesLoading,
    selectedReassignInbox,
    setSelectedReassignInbox,
    handleDeleteInbox,
    removeModal,
    checkboxStates,
    setCheckboxState,
    isDeleteDisabled,
    deleteInboxLoading,
  } = store

  return (
    <div className={styles.container}>
      <Box display={'flex'} flexDirection={'column'} gap={'18px'}>
        <Typography
          variant={'body-md-regular'}
          color={'var(--content-primary-tertiary)'}
          ariaLabel={'DeleteInboxDescription'}
        >
          By deleting this inbox, I understand that:
        </Typography>
        <Box display={'flex'} flexDirection={'column'} gap={'12px'} marginBottom={'8px'}>
          {DELETE_INBOX_CHECKBOXES.map((checkbox) => (
            <label key={checkbox.id} className={styles.wrapCheckbox} htmlFor={checkbox.id}>
              <Checkbox
                id={checkbox.id}
                checked={checkboxStates[checkbox.id]}
                onChange={(checked) => setCheckboxState(checkbox.id, checked)}
                ariaLabel={checkbox.id}
                size={16}
              />
              <Typography
                variant={'body-md-regular'}
                color={'var(--content-primary-primary)'}
                ariaLabel={`${checkbox.id}Label`}
              >
                {checkbox.label}
              </Typography>
            </label>
          ))}
        </Box>
        <SelectField
          labelText={'Reassign conversations to:'}
          value={selectedReassignInbox?.id}
          loading={availableInboxesLoading}
          setValue={(id) => {
            const inbox = availableInboxes.find((i) => i.id === id)
            if (inbox) {
              setSelectedReassignInbox(inbox.origin)
            }
          }}
          items={availableInboxes.map((inbox) => ({
            id: inbox.id,
            label: inbox.name,
            iconL: 'inboxes2',
          }))}
          selectProps={{
            placeholder: 'Select inbox',
          }}
          withSearch={true}
          size={'medium'}
          btnProps={{
            placeholder: 'Select inbox',
            text: selectedReassignInbox ? selectedReassignInbox.name : 'Select inbox',
            textIcon: 'inboxes2',
            textIconColor: 'var(--content-primary-tertiary)',
            style: {
              height: '40px',
              color: !selectedReassignInbox ? 'var(--content-neutral-primary)' : undefined,
            },
          }}
        />
      </Box>

      <div className={styles.actions}>
        <Button text='Cancel' contained='secondary' onClick={removeModal} />
        <Button
          text={'Delete inbox'}
          typeBtn={'contained'}
          contained={'secondary'}
          intent={'destructive'}
          disabled={isDeleteDisabled || deleteInboxLoading}
          onClick={handleDeleteInbox}
        />
      </div>
    </div>
  )
})
